'use client';

import { getMaxNumberOfSubAccounts } from '@velocity-exchange/sdk';
import useVelocityClient from './useVelocityClient';

/**
 * Returns true if the current number of subaccounts on the protocol is greater than or equal to the max number of subaccounts.
 */
export const useMaxSubaccountsReached = () => {
	const velocityClient = useVelocityClient();

	const stateAccount = velocityClient?.getStateAccount();

	if (!stateAccount) {
		return false;
	}

	const maxNumberOfSubAccounts = getMaxNumberOfSubAccounts(stateAccount);

	if (maxNumberOfSubAccounts.isZero()) {
		// if the max number of subaccounts is zero, that means there is no limit on the number of subaccounts
		return false;
	}

	const currentNumberOfSubAccounts = stateAccount.numberOfSubAccounts;

	return currentNumberOfSubAccounts.gte(maxNumberOfSubAccounts);
};
